import { useEffect, useState } from 'react';
import Editor from 'react-simple-code-editor';
import Prism from 'prismjs';
import 'prismjs/components/prism-css';
import 'prismjs/plugins/line-numbers/prism-line-numbers';
import 'prismjs/themes/prism.css';
import { ValidateCss } from '../../../connection/custom';
import './edit-css.scss';
import ModalComponent from '../modal/modal';

interface CustomCssProps {
	value: string;
	onChange: (value: string) => void;
	open: boolean;
	onClose: () => void;
}

export default function CustomCSS({ value, onChange, open, onClose }: CustomCssProps): JSX.Element {
	// const { workingEvent } = useSelector((state: EventsState) => state.CreateEventReducer);
	const [code, setCode] = useState(value);
	const [cssErrors, setCssErrors] = useState([]);
	// const dispatch = useDispatch();

	function updateCode(code: string) {
		setCode(code);
	}

	function highlight(code: any) {
		return Prism.highlight(code, Prism.languages.css, 'css');
	}

	async function save() {
		if (code) {
			const validation = await ValidateCss(code);
			setCssErrors(validation);

			if (validation.length === 0) {
				onChange(code);
				onClose();
			}
		} else {
			onChange('');
			onClose();
		}
	}

	useEffect(() => {
		if (!code) {
			setCode(value);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value]);

	function close() {
		// cancel any edits made in the current modal
		setCode(value);
		onClose();
	}


	return (
		<ModalComponent
			title={"Edit Custom CSS"}
			footer={(
				<>
					<button onClick={close}>Cancel</button>
					<button onClick={save} className="primary">
						Save
					</button>
				</>
			)}
			cancellable={true}
			closeable={false}
			open={open}
			onRequestClose={close}
		>
			<div className="custom-css-container">
				<Editor
					value={code}
					className="style-editor"
					onValueChange={updateCode}
					// onBlur={handleBlur}
					highlight={highlight}
					padding={10}
					style={{
						fontFamily: "Roboto Mono",
						fontSize: 12
					}}
				/>

				{cssErrors.map((err: any, index: number) => (
					<div key={index} className="css-error">
						<label>CSS Error</label>
						<br />
						<div className="error-block">
							<code className="error-label">Message:</code>
							<code>{err.message}</code>
						</div>
						<div className="error-block">
							<code className="error-label">Line:</code>
							<code>{err.line - 1}</code>
						</div>
					</div>
				))}
			</div>
		</ModalComponent>
	);
}